<template>
  <div class="news-page">
    <!-- Banner -->
    <div class="ban" style="background-image: url('/images/ban1.jpg'); ">
    </div>

    <!-- Content -->
    <div class="main">
      <div class="wp">
        <div class="g-top">
          <div class="tab">
            <ul>
              <!-- <li :class="{ 'on': activeTab === 'industry' }">
                <a href="javascript:void(0)" @click="setActiveTab('industry')">行业动态</a>
              </li> -->
              <li :class="{ 'on': activeTab === 'company' }">
                <a href="javascript:void(0)" @click="setActiveTab('company')">公司新闻</a>
              </li>
              <li :class="{ 'on': activeTab === 'product' }">
                <a href="javascript:void(0)" @click="setActiveTab('product')">最新产品</a>
              </li>
            </ul>
          </div>
          <div class="cur">
            当前位置：
            <a href="/">首页</a> &gt;
            <a href="javascript:void(0)">新闻资讯</a> &gt;
            <span v-if="activeTab === 'company'">公司新闻</span>
            <span v-if="activeTab === 'product'">最新产品</span>
          </div>
        </div>
      </div>

      <!-- 新闻列表 - 当未显示详情时显示 -->
      <div v-if="!showingNewsDetail" class="wp">
        <ul class="m-list4">
          <li v-for="news in allNews" :key="news.id">
            <a href="#" class="con" @click.prevent="viewNewsDetail(news)">
              <div class="pic">
                <img :src="news.newImg" :alt="news.title">
              </div>
              <h3>{{ news.newNameEn }}</h3>
              <span class="date">{{ news.createTime }}</span>
              <div class="desc">{{ news.newSynopsisCn }}</div>
              <span class="btn">查看详情</span>
            </a>
          </li>
        </ul>
        <div class="pages">
          <ul>
            <!-- 分页内容可以根据需要实现 -->
          </ul>
        </div>
      </div>
      
      <!-- 新闻详情组件 - 通过props传递数据，只有在showingNewsDetail为true时显示 -->
      <div v-if="showingNewsDetail" >
        <div >
          <component-news-detail :article="currentArticle" :all-news="allNews" @close-detail="closeNewsDetail" @view-article="handleViewArticle" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RequestUtil from '../utils/request';
export default {
  name: 'News',
  data() {
    return {
      activeTab: 'company', // 默认显示公司新闻
      showingNewsDetail: false, // 控制是否显示新闻详情
      currentArticle: null, // 当前显示的新闻详情
      allNews: []
    }
  },

  components: {
    ComponentNewsDetail: () => import('./NewsDetail.vue')
  },
  computed: {
    filteredNewsList() {
      // 根据当前活动标签过滤新闻列表
      // if (this.activeTab === 'all') {
      //   return this.allNews;
      // }
      // 对于API返回的数据，使用newType字段进行过滤
      return this.allNews.filter(news => {
        // 检查newType字段，1表示公司新闻，0表示产品新闻
        if (typeof news.newType !== 'undefined') {
          return (this.activeTab === 'company' ? news.newType === 1 : news.newType === 0);
        }
        // 如果没有newType字段，使用type字段
        return news.type === this.activeTab;
      });
    }
  },
  mounted() {
    // 从URL哈希获取当前标签
        this.updateActiveTabFromRoute(this.$route);
      // this.getNewsList();
   

    this.$watch(
      () => this.$route,
      (to, from) => {
        this.updateActiveTabFromRoute(to);
      }
    );
  },
  // watch: {
  //   '$route'(to, from) {
  //     // 监听路由变化，更新标签
  //     this.setActiveTabFromRoute();
  //   }
  // },
  methods: {
    getNewsList() {
      let type  =  this.activeTab == 'company' ? '1' : '0';
      RequestUtil.get('/wx/news/list?type=' + type).then(response => {
        // 确保API返回的数据正确赋值给allNews
        this.allNews = Array.isArray(response.data) ? response.data : [];
        // 如果需要，可以在这里对数据进行预处理
      });
    },
        updateActiveTabFromRoute(route) {
      const hash = route.hash; // 或者使用 route.fullPath
      // alert(hash)
      if (hash === '#new-product') {
        this.activeTab = 'product';
      }  else {
        this.activeTab = 'company';
      }
      this.getNewsList()
    },
    setActiveTab(tab) {
      this.activeTab = tab;
      this.getNewsList();
      // 如果当前正在显示详情，则关闭详情视图并回到列表
      // 如果只是切换标签，则保持当前状态
      if (this.showingNewsDetail) {
        this.showingNewsDetail = false;
        this.currentArticle = null;
      }
    },
    viewNewsDetail(news) {
      // 显示新闻详情，确保数据格式正确
      this.currentArticle = {
        id: news.id || news.newId,
        title: news.title || news.newNameCn,
        content: news.content || news.newContentCn,
        image: news.image || news.newImg,
        createTime: news.createTime || news.newCreateTime,
        source: news.source || news.newSource,
        views: news.views || news.newViews || 0,
        description: news.description || news.newSynopsisCn,
        type: news.type || (news.newType === 1 ? 'company' : 'product'),
        newType: news.newType
      };
      this.showingNewsDetail = true;
      
      // 更新 SEO - 使用文章标题和摘要
      this.updateArticleSEO(this.currentArticle);
    },
    
    // 更新文章详情页 SEO
    updateArticleSEO(article) {
      const title = article.title + ' - 北京西宝电子技术有限责任公司';
      const description = article.description || article.content?.substring(0, 150).replace(/<[^>]+>/g, '') || '北京西宝电子新闻资讯';
      const keywords = '西宝电子,' + (article.type === 'company' ? '公司新闻' : '产品资讯') + ',微波器件,毫米波产品';
      
      // 更新标题
      document.title = title;
      
      // 更新 description
      let descMeta = document.querySelector('meta[name="description"]');
      if (descMeta) descMeta.content = description;
      
      // 更新 keywords - 包含后台分类
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (keywordsMeta) keywordsMeta.content = keywords;
      
      // 更新 Open Graph
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.content = title;
      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.content = description;
    },
    closeNewsDetail() {
      // 关闭新闻详情
      this.showingNewsDetail = false;
      this.currentArticle = null;
      
      // 恢复列表页 SEO
      this.restoreListSEO();
    },
    
    // 恢复新闻列表页 SEO
    restoreListSEO() {
      const meta = this.$route.meta || {};
      document.title = meta.title || '新闻资讯 - 北京西宝电子技术有限责任公司';
      
      let descMeta = document.querySelector('meta[name="description"]');
      if (descMeta && meta.description) descMeta.content = meta.description;
      
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (keywordsMeta && meta.keywords) keywordsMeta.content = meta.keywords;
    },
    handleViewArticle(article) {
      // 处理从详情页跳转到其他文章
      this.currentArticle = {
        id: article.id || article.newId,
        title: article.title || article.newNameCn,
        content: article.content || article.newContentCn,
        image: article.image || article.newImage,
        createTime: article.createTime || article.newCreateTime,
        source: article.source || article.newSource,
        views: article.views || article.newViews || 0,
        description: article.description || article.newSynopsisCn,
        type: article.type || (article.newType === 1 ? 'company' : 'product'),
        newType: article.newType
      };
      this.showingNewsDetail = true;
      
      // 更新 SEO
      this.updateArticleSEO(this.currentArticle);
    }
  }
}
</script>

<style  scoped>
 @media only screen and (max-width: 1199px) {
    .ban ,.g-top {
      display: block !important;
     
    }
    .g-top{
       margin-top: -5vw;
       box-shadow: 0px 2px 21px 0px rgba(0,24,52,0.07);
       background: #FFFFFF;
       height: 44px;
       line-height: 44px;
       
      
    }
    .g-top .tab li a{
      font-size: 12px !important;
    }
}
</style>